
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.73.02a5.014 5.014 0 00-4.449 3.37c-.207.604-.288 1.21-.29 2.165l-.001.44-1.117.012c-.961.01-1.14.019-1.277.064-.267.088-.458.3-.543.604-.018.066-.264 2.874-.545 6.24C.054 18.342 0 19.058.029 19.24c.04.254.111.397.267.538.243.219-.486.202 8.689.202 7.227 0 8.273-.006 8.405-.045a.764.764 0 00.569-.595l.051-.204-.501-6.035c-.276-3.32-.514-6.129-.531-6.243-.04-.28-.13-.474-.284-.615-.229-.212-.299-.223-1.567-.236l-1.117-.012-.001-.44c-.002-.616-.044-1.167-.119-1.536A4.988 4.988 0 0010.205.167 5.307 5.307 0 008.73.02m1.035 2.079c.281.077.66.248.906.411.392.259.804.729 1.021 1.165.241.483.308.855.308 1.699V6H6v-.648c0-.709.045-1.041.193-1.418a3.04 3.04 0 012.252-1.882c.315-.061 1.013-.036 1.32.047M3.99 8.453c.001.789.063 1.085.271 1.293.18.181.326.226.734.227.336.002.372-.004.532-.082a.737.737 0 00.399-.451c.043-.124.057-.282.067-.793l.013-.637h5.988l.013.637c.01.511.024.669.067.793a.737.737 0 00.399.451c.16.078.196.084.532.082.408-.001.554-.046.734-.227.208-.208.27-.504.271-1.293V8.01h.54c.54 0 .54 0 .542.068 0 .037.187 2.284.413 4.994L15.917 18H2.083l.412-4.928c.226-2.71.413-4.957.413-4.994.002-.068.002-.068.542-.068h.54v.443","fill-rule":"evenodd","fill":"currentColor"}})])
          )
        }
      }
    